import badge from './badge';
import button from './button';
import tooltip from './tooltip';
import notification from './notification';
import modal from './modal';
import fieldset from './fieldset';
import input from './input';
import actionIcon from './action-icon';
import paper from './paper';
import popover from './popover';
import switchOverride from './switch';

export default {
    ...badge,
    ...button,
    ...fieldset,
    ...tooltip,
    ...notification,
    ...modal,
    ...input,
    ...actionIcon,
    ...paper,
    ...popover,
    ...switchOverride,
}